import PazienteTerapiaList from "./pages/PazienteTerapiaList";
import PazienteTerapiaView from "./components/PazienteTerapiaView";
import PazienteTerapiaEdit from "./components/PazienteTerapiaEdit";
export default {
    PazienteTerapiaList,
    PazienteTerapiaView,
    PazienteTerapiaEdit,
};
